{
  "overridesEnabledBadgeLabel": "覆盖于"
}
